import React, { useEffect, useRef } from "react";
import useFirebase from "../hooks/useFirebase";
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { isLoggedIn, logout, silentLogout, isPremium } from "../services/auth";

const Status = ({ signInSuccessUrl, title }) => {
  const mounted = useRef(false);
  // eslint-disable-next-line no-unused-vars
  const firebaseInitialized = useFirebase();
  const { auth } = require('../../firebaseConfig');
  const baseClass = "w-auto text-center inline-block h-auto py-2 px-3 md:px-4 my-2 mr-2 hover:bg-black focus:outline-hidden text-white text-sm md:text-lg font-medium transition-all duration-300 ease-in-out shadow-md"

  useEffect(() => {
    mounted.current = true;
    return () => mounted.current = false;
  }, []);

  if (isLoggedIn()) {
    return(
      <>
        <Link
          to="/subscription"
          state={{ title, pay: !isPremium() }}
          role="button"
          tabIndex={0}
          id="topbar-account"
          className={`${baseClass} ${isPremium() ? 'bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900' : 'bg-gradient-to-r from-green-800 to-green-900 hover:from-green-900 hover:to-black'} text-white`}
          activeClassName="bg-black text-white"
        >
          {isPremium() ? 'My Account' : 'Join Now'}
        </Link>
        <div
          role="button"
          tabIndex={0}
          onClick={ () => logout(auth, mounted) }
          onKeyDown={ () => logout(auth, mounted) }
          id="topbar-sign-out-button"
          className={`${baseClass} bg-gradient-to-r from-red-600 to-red-800 hover:from-red-700 hover:to-red-900`}>
          Sign Out
        </div>
      </>
    )
  } else {
    return(
      <Link
        to="/login"
        state={{ signInSuccessUrl, title }}
        className={ `bg-gradient-to-r from-green-800 to-green-900 hover:from-green-900 hover:to-black ${baseClass}` }
        onClick={() => silentLogout({ auth, mounted })}
        onKeyDown={() => silentLogout({ auth, mounted })}
        id="topbar-login-button"
      >
        Login
      </Link>
    )
  }
}

Status.propTypes = {
  signInSuccessUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
}


export default Status
